const getImageUrlString = (image: string | null | undefined): string | undefined => {
  const dataImage = (image?.indexOf('data:image') ?? -1) >= 0;
  const base64 = !dataImage && (image?.indexOf('://') ?? -1) < 0 && image?.charAt(0) !== '/';
  const prefix = base64 ? 'data:image/jpeg;base64,' : '';
  return image == null ? undefined : `url("${prefix + image}")`;
};

export default getImageUrlString;
